import { OfferType } from '@smg-real-estate/hg-rets-schema';
import { ListerBranding } from '@smg-real-estate/hg-search-libs';
import { computed, type ComputedRef, type MaybeRefOrGetter, toValue } from 'vue';
import { useRoute } from 'vue-router';

import FeatureFlags from '@/helpers/FeatureToggle/FeatureFlags';
import { isFeatureEnabled } from '@/helpers/FeatureToggle/FeatureToggleHelper';
import { getPartnerBadge, type PartnerBadge } from '@/helpers/partnerBadge/getPartnerBadge';

export function usePartnerBadge(
  offerType: MaybeRefOrGetter<OfferType | undefined>,
  listerBranding: MaybeRefOrGetter<ListerBranding | null | undefined>,
): {
  partnerBadge: ComputedRef<PartnerBadge | null>;
  isPartnerBadgeEnabled: ComputedRef<boolean>;
} {
  const route = useRoute();

  const isPartnerBadgeEnabled = computed(() =>
    isFeatureEnabled(FeatureFlags.ENABLE_PARTNER_BADGE, route),
  );
  const partnerBadge = computed(() => {
    if (!isPartnerBadgeEnabled.value || toValue(offerType) !== OfferType.Buy) {
      return null;
    }
    return getPartnerBadge(toValue(listerBranding)?.basePackage);
  });

  return { partnerBadge, isPartnerBadgeEnabled };
}
